import {
  call, put, takeEvery, select, all, takeLatest,
} from 'redux-saga/effects';
import moment from 'moment';
import { authRequest } from '../../helpers/request.helper';
import {
  ENCARGOS_CREACION_BUSCAR_GRADUACION_REQUEST,
  ENCARGOS_CREACION_BUSCAR_GRADUACION_SUCCESS,
  ENCARGOS_CREACION_ESTABLECER_CLIENTE,
  ENCARGOS_CREACION_INICIALIZAR_REQUEST,
  ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA,
  ENCARGOS_CREACION_APLICAR_DESCUENTO,
  ENCARGOS_CREACION_INICIALIZAR_SUCCESS,
  ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_SUCCESS,
  ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_FAILURE,
  ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_REQUEST,
  ENCARGOS_CREACION_BORRAR_DESCUENTO,
  ENCARGOS_CREACION_GUARDAR_REQUEST,
  ENCARGOS_CREACION_GUARDAR_FAILURE,
  ENCARGOS_CREACION_GUARDAR_SUCCESS,
  ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA,
  ENCARGOS_CREACION_ARTICULOS_AGREGAR_LINEA,
  ENCARGOS_CREACION_APLICAR_ERRORES_FORMULARIO,
  ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA,
  ENCARGOS_CREACION_ARTICULOS_CREAR_ESTABLECER_A_LINEA,
  ENCARGOS_CREACION_SET_GAFA_GRADUADA,
} from '../actions/constants/encargos.creador.constants';
import {
  establecerGraduaciones,
  addArticulo,
  modificarPrecioLinea,
  addFormaArticulo,
  agregarLinea,
  expandirEncargo,
  establecerArticulo,
  setLentes,
  addArticuloTemporal,
} from '../actions/creators/encargos.creador.actioncreator';
import { showDanger, showInfo, toastDanger } from '../actions/creators/mensajesSistema.actioncreator';
import { iniciarVentanaTrazadora } from '../actions/creators/trazadora.actioncreator';
import EncargoSimpleBuilder from '../../modules/encargos/model/builder/EncargoSimple.creador';
import DetalleEncargoCreador from '../../modules/encargos/model/builder/DetalleEncargo.creador';
import { calcularBonificacionEstatica, calcularBonificacionVariable } from '../../helpers/modules/bonificaciones.helper';
import history from '../../history';


function obtenerEstructuraEncargoPromocional({ packs, gestorId, uuid }) {
  return packs.map((pack) => {
    const encargo = EncargoSimpleBuilder.build({ gestorId, uuid });
    const { pack: infoPack, estructura } = pack;
    const estructuraDetalles = estructura.map((estructura) => {
      const {
        posicion, etiqueta, unidades, id, obligatorio, cdgtipo,
      } = estructura;
      return DetalleEncargoCreador.build({
        cdgtipo, etiqueta, linea: posicion, obligatorio, estructuraId: id, unidades,
      });
    });
    const { nombre } = infoPack;
    encargo.pack = infoPack;
    encargo.detalles = estructuraDetalles;
    encargo.nombre = nombre;
    return encargo;
  });
}

function* obtenerEstructuraPromocionDesdeServidor({ promocionId }) {
  const formData = new FormData();
  formData.append('consulta', JSON.stringify({ id: { valor: promocionId } }));
  const params = {
    url: 'api/promociones/buscar',
    method: 'POST',
    body: formData,
  };
  const response = yield call(authRequest, params);
  const { datos, total } = response;
  if (total === 1) {
    return datos[0];
  }
  return undefined;
}
const authState = state => state.auth;
const encargosCreadorState = state => state.encargosCreador;

function* inicializarCreadorEncargos({ payload }) {
  try {
    const auth = yield select(authState);
    const { user: { user_info: { tienda_id: tiendaId, usuario_id: usuarioId } } } = auth;
    const { esPresupuesto, promocionId, uuid } = payload;
    let encargos = [];
    let promocion = null;
    let titulo = 'Sin Promocion';
    if (promocionId === undefined || promocionId === null) {
      const encargo = EncargoSimpleBuilder.build({ gestorId: usuarioId, uuid });
      encargos.push(encargo);
    } else {
      promocion = yield obtenerEstructuraPromocionDesdeServidor({ promocionId });
      const { packs, nombre } = promocion;
      titulo = `Promocion ${nombre}`;
      encargos = obtenerEstructuraEncargoPromocional({ packs, gestorId: usuarioId, uuid });
    }
    yield put({
      type: ENCARGOS_CREACION_INICIALIZAR_SUCCESS,
      payload: {
        tiendaId, esPresupuesto, encargos, promocion, titulo,
      },
    });
  } catch (ex) {
    console.log(ex);
  }
}

function* afterEstablecerCliente({ payload }) {
  if (payload) {
    const { cliente, encargoUUID } = payload;
    if (cliente) {
      const { id: pacienteId, fechaUltimaGraduacionOptometrica, fechaUltimaGraduacionContactologica } = cliente;

      const graduaciones = {
        optometricas: [],
        contactologicas: [],
      };
      if (fechaUltimaGraduacionContactologica || fechaUltimaGraduacionOptometrica) {
        yield put({ type: ENCARGOS_CREACION_BUSCAR_GRADUACION_REQUEST });
        if (fechaUltimaGraduacionContactologica) {
          try {
            const formDataContactologico = new FormData();
            formDataContactologico.append('consulta', JSON.stringify({ codigo_cliente: { valor: pacienteId } }));
            formDataContactologico.append('limite', 50);
            formDataContactologico.append('orden', JSON.stringify({ fecha: 'DESC' }));

            const paramsContactologica = { url: 'api/graduacioncontactologica/buscar', method: 'POST', body: formDataContactologico };
            const { datos: datosContactologica } = yield call(authRequest, paramsContactologica);
            graduaciones.contactologicas = datosContactologica;
          } catch (ex) {

          }
        }
        if (fechaUltimaGraduacionOptometrica) {
          try {
            const formDataOptometrico = new FormData();
            formDataOptometrico.append('consulta', JSON.stringify({ paciente_id: { valor: pacienteId } }));
            formDataOptometrico.append('limite', 50);
            formDataOptometrico.append('orden', JSON.stringify({ fecha: 'DESC' }));
            const paramsOptometrica = { url: 'api/graduacionoptometrica/buscar', method: 'POST', body: formDataOptometrico };
            const { datos: datosOptometrica } = yield call(authRequest, paramsOptometrica);
            graduaciones.optometricas = datosOptometrica;
          } catch (ex) {

          }
        }
      }

      yield put(establecerGraduaciones({ encargoUUID, graduaciones }));
      yield put({ type: ENCARGOS_CREACION_BUSCAR_GRADUACION_SUCCESS });
    }
  }
}

function* buscarYAgregarArticuloPorCodigo({ payload }) {
  if (payload) {
    const { encargoUUID, linea, codigo } = payload;
    let encargoSeleccionado;
    if (encargoUUID && codigo && codigo.length > 0) {
      const encargosCreador = yield select(encargosCreadorState);
      const { encargos } = encargosCreador;
      const filter = { busc_codigo: { valor: codigo, operador: 'virtual' } };
      if (encargos) {
        encargoSeleccionado = encargos.find(encargo => encargo.uuid === encargoUUID);
        if (encargoSeleccionado && linea > 0) {
          const { detalles } = encargoSeleccionado;
          if (detalles) {
            const detalle = detalles.find(detalle => detalle.linea === linea);
            if (detalle) {
              const { estructuraId, cdgtipo } = detalle;
              if (estructuraId) {
                filter.estructura_id = { valor: estructuraId };
              }
              if (cdgtipo >= 0) {
                filter['tipo.id'] = { valor: cdgtipo };
              }
            }
          }
        }
      }
      try {
        yield put({ type: ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_REQUEST });
        const formData = new FormData();
        formData.append('consulta', JSON.stringify(filter));
        formData.append('limite', 1);
        const params = { url: 'api/articulos/buscar', method: 'POST', body: formData };
        const { datos } = yield call(authRequest, params);
        if (datos) {
          if (datos.length === 0) {
            yield put(showInfo({ title: 'No se han encontrado artículos' }));
          } else {
            const articulo = datos[0];
            let lineaToModify = linea;
            if (linea === undefined || linea === null) {
              const { detalles } = encargoSeleccionado;
              lineaToModify = detalles.length + 1;
              const { codigo_tipo: codigoTipo } = articulo;

              yield put(agregarLinea({ encargoUUID, agrupacion: [codigoTipo] }));
            }
            yield put(addArticulo({ encargoUUID, linea: lineaToModify, articulo }));
          }
        }
        yield put({ type: ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_SUCCESS });
      } catch (ex) {
        yield put({ type: ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA_FAILURE, payload: ex });
      }
    }
  }
}
function* agregarArticuloLinea({ payload }) {
  if (payload) {
    const { encargoUUID, linea, articulo } = payload;
    let encargoSeleccionado;
    if (encargoUUID) {
      const encargosCreador = yield select(encargosCreadorState);
      const { encargos } = encargosCreador;
      if (encargos) {
        encargoSeleccionado = encargos.find(encargo => encargo.uuid === encargoUUID);
        if (encargoSeleccionado && linea > 0) {
          const { detalles } = encargoSeleccionado;
          if (detalles) {
            const detalle = detalles.find(detalle => detalle.linea === linea);
            if (!detalle) {
              const { codigo_tipo: codigoTipo } = articulo;
              yield put(agregarLinea({ encargoUUID, agrupacion: [codigoTipo] }));
            }
            yield put(establecerArticulo({ encargoUUID, linea, articulo }));
          }
        }
      }
    }
  }
}
function* obtenerFormaMontura({ payload }) {
  if (payload) {
    const datosForma = { forma_oma_montura: null, fecha_modificacion_forma_oma: null, admite_biselado_forma_oma: null };
    const { encargoUUID, linea, articulo } = payload;
    const auth = yield select(authState);
    const { permisos: { configuracion: { articulo_monturas, articulo_sol } } } = auth;
    const formData = new FormData();
    if (articulo.codigo_tipo == articulo_monturas || articulo.codigo_tipo == articulo_sol) {
      formData.append('codigoArticulo', articulo.codigo);
      formData.append('tipoArticulo', articulo.codigo_tipo);
      formData.append('extraInfo', JSON.stringify({ cdg_fabricante: articulo.fabricante_id, edi: articulo.codigo_EDI, upc: articulo.codigo_barra }));
      const paramsForma = { url: 'api/articulos/obtenerForma', method: 'POST', body: formData };
      try {
        yield put({ type: 'OBTENER_FORMA_MONTURA_REQUEST' });
        const resultado = yield call(authRequest, paramsForma);
        if (resultado) {
          datosForma.forma_oma_montura = resultado.OMA;
          datosForma.fecha_modificacion_forma_oma = resultado.FECHA_MODIFICACION;
          datosForma.admite_biselado_forma_oma = resultado.ADMITE_BISELADO;
        }
        yield put({ type: 'OBTENER_FORMA_MONTURA_SUCCESS' });
      } catch (e) {
        yield put({ type: 'OBTENER_FORMA_MONTURA_FAILURE', payload: e });
        return;
      }
    }
    yield put(addFormaArticulo({ encargoUUID, linea, datosForma }));
  }
}
function* setGafaGraduada({ payload }) {
  if (payload) {
    yield put(addArticuloTemporal(payload));
    yield put(setLentes(payload));
  }
}

function* recalcularPrecioArticulo({ payload }) {
  if (payload) {
    const { encargoUUID, linea } = payload;
    const encargosCreador = yield select(encargosCreadorState);
    const { encargos } = encargosCreador;
    if (encargos) {
      const encargo = encargos.find(encargo => encargo.uuid === encargoUUID);
      if (encargo) {
        const { detalles } = encargo;
        if (detalles) {
          const detalle = detalles.find(detalle => detalle.linea === linea);
          if (detalle) {
            const { articulo: { pvp: precioOriginal }, descuento } = detalle;
            const { bonificacionVariable, bonificacionesEstaticas } = descuento;
            let precio = precioOriginal;
            const { precioAlza } = bonificacionVariable;
            if (precioAlza !== null && precioAlza !== undefined) precio = precioAlza;
            precio = calcularBonificacionVariable({ precioOriginal: precio, bonificacion: bonificacionVariable });
            precio = calcularBonificacionEstatica({ precioOriginal: precio, bonificaciones: bonificacionesEstaticas });
            yield put(modificarPrecioLinea({ encargoUUID, linea, precio }));
          }
        }
      }
    }
  }
}
function* guardarEncargos() {
  try {
    const encargosCreador = yield select(encargosCreadorState);
    const {
      encargos, esPresupuesto, tiendaId, promocion,
    } = encargosCreador;

    const erroresEncargos = {};
    let hayErrores = false;
    let noHayDetalles = false;
    encargos.forEach((encargo) => {
      erroresEncargos[encargo.uuid] = {};
    });

    encargos.forEach((encargo) => {
      const { uuid, cabecera, detalles } = encargo;

      if (detalles.length === 0) {
        erroresEncargos[uuid].detalles = { hasErrors: true, isEmpty: true };
        noHayDetalles = true;
      }
      if (cabecera) {
        const { tipoEncargoId } = cabecera;
        if (tipoEncargoId === undefined || tipoEncargoId === null) {
          erroresEncargos[uuid].tipoEncargoId = { hasErrors: true };
          hayErrores = true;
        }
      }
    });
    if (hayErrores || noHayDetalles) {
      yield put({ type: ENCARGOS_CREACION_GUARDAR_FAILURE });
      yield put({ type: ENCARGOS_CREACION_APLICAR_ERRORES_FORMULARIO, payload: { errores: erroresEncargos } });
      if (hayErrores) {
        yield put(toastDanger({ message: 'Hay errores en el formulario' }));
      } else if (noHayDetalles) {
        yield put(toastDanger({ message: 'No hay artículos en el encargo' }));
      }
    } else {
      const requestObject = {
        test: true,
        es_presupuesto: esPresupuesto,
        tienda_id: tiendaId,
        promocion_id: promocion ? promocion.id : null,
        encargos: encargos.map((encargo) => {
          const {
            cabecera, cabecera: { cliente }, detalles, pack,
          } = encargo;
          const packId = pack ? pack.id : null;
          const { graduaciones: graduacionesCliente } = cliente;
          const graduaciones = {
            optometrica: null,
            contactologica: null,
          };
          if (graduacionesCliente) {
            const { optometricas, contactologicas } = graduacionesCliente;
            const { seleccion: seleccionOptometricas } = optometricas;
            if (seleccionOptometricas && seleccionOptometricas.id !== null && seleccionOptometricas.tiendaId !== null) {
              graduaciones.optometrica = {
                id: null,
                tienda_id: null,
              };
              graduaciones.optometrica.id = seleccionOptometricas.id;
              graduaciones.optometrica.tienda_id = seleccionOptometricas.tiendaId;
            }
            const { seleccion: seleccionContactologicas } = contactologicas;
            if (seleccionContactologicas && seleccionContactologicas.id !== null && seleccionContactologicas.tiendaId !== null) {
              graduaciones.contactologica = {
                id: null,
                tienda_id: null,
              };
              graduaciones.contactologica.id = seleccionContactologicas.id;
              graduaciones.contactologica.tienda_id = seleccionContactologicas.tiendaId;
            }
          }
          return {
            pack_id: packId,
            tienda_virtual: null,
            cabecera: {
              cliente: {
                id: cliente.id,
                nombre_completo: cliente.nombreCompleto,
                graduaciones,
                tienda_id: cliente.tiendaId,
              },
              tipo_encargo_id: cabecera.tipoEncargoId,
              motivo_compra_id: cabecera.motivoVisitaId,
              gestor_id: cabecera.gestorId,
              numero_talon: cabecera.numeroTalon,
              tarjeta_fidelizacion: {
                id: null,
                contenido: null,
              },
              cupon: null,
              observaciones: cabecera.observaciones,
              observaciones_taller: null,
              fecha_creacion: cabecera.fechaCreacion.format('YYYY-MM-DD'),
              fecha_entrega: cabecera.fechaEntrega.format('YYYY-MM-DD'),
            },
            detalles: detalles.map((detalle) => {
              const {
                articulo, descuento,
              } = detalle;
              const { bonificacionVariable, bonificacionesEstaticas } = descuento;
              const {
                cantidad, tipo, id: bonificacionId, precioAlza,
              } = bonificacionVariable;
              const articuloAGuardar = {
                id: articulo.id,
                pvp: articulo.pvp,
                pvo: articulo.pvo,
                descripcion: articulo.descripcion,
                codigo_tipo: articulo.codigoTipo,
              };
              if (articuloAGuardar.codigo_tipo === 1 && articulo.infoLente) {
                const infoLente = {
                  ojo: articulo.infoLente.ojo === 'derecho' ? 'D' : 'I',
                  vision: articulo.infoLente.foco.vision === 'lejos' ? 'L' : 'C',
                  diametro: articulo.infoLente.diametro,
                  pvp: articulo.infoLente.pvp,
                  pvo: articulo.infoLente.pvo,
                  descripcion: articulo.infoLente.descripcion,
                  suplementos: articulo.infoLente.suplementos.map(e => ({
                    id: e.id,
                    codigo_control: e.control,
                    tipo: e.tipoSuplemento,
                    pvo: e.pvo,
                    pvp: e.pvp,
                    descripcion: e.descripcion,
                    incluido_mi_catalogo: e.incluidoMiCatalogo,
                    obligatorio: e.obligatorio,
                  })),
                  info_trazadora: articulo.infoLente.info_trazadora,
                  altura_focal: articulo.infoLente.alturaFocal,
                };
                if (articulo.infoLente.estadistica) {
                  infoLente.estadistica = {
                    catalogo_detalle_id: articulo.infoLente.estadistica.catalogoDetalleId,
                    mi_catalogo_id: articulo.infoLente.estadistica.miCatalogoId,
                    color_detalle_id: articulo.infoLente.estadistica.colorDetalleId,
                    tipo_progresivo_id: articulo.infoLente.estadistica.tipoProgresivoId,
                  };
                }
                articuloAGuardar.info_lente = infoLente;
              }
              return {
                linea: detalle.linea,
                precio: detalle.precio,
                unidades: detalle.unidades,
                articulo: articuloAGuardar,
                descripcion: detalle.descripcion,
                descuento: cantidad !== null ? { cantidad, tipo, id: bonificacionId } : null,
                bonificaciones: bonificacionesEstaticas.map(({ id }) => ({ id })),
                pcto_impuesto: 7,
                precio_alza: precioAlza !== articulo.pvp ? precioAlza : null,
                estructura_pack_id: null,
              };
            }),
          };
        }),
      };
      const params = {
        url: 'api/encargos/v2/crear',
        method: 'POST',
        body: requestObject,
      };
      const respuesta = yield call(authRequest, params);
      if (respuesta) {
        if (respuesta.length > 0) {
          const datosRespuesta = respuesta[0];
          const { id, tienda } = datosRespuesta;
          yield put({ type: ENCARGOS_CREACION_GUARDAR_SUCCESS, payload: { response: { id, tienda } } });
        }
      }
    }
  } catch (exception) {
    yield put({ type: ENCARGOS_CREACION_GUARDAR_FAILURE, payload: exception });
    yield put(showDanger({ title: 'No ha sido posible crear el encargo' }));
  }
}

function* validarErroresFormulario({ payload }) {
  const { encargoUUID, nombre, valor } = payload;
  if (encargoUUID && nombre && valor) {
    const erroresEncargos = {};
    erroresEncargos[encargoUUID] = {};
    erroresEncargos[encargoUUID][nombre] = { hasErrors: false };
    yield put({ type: ENCARGOS_CREACION_APLICAR_ERRORES_FORMULARIO, payload: { errores: erroresEncargos } });
  }
}

function* authenticationRequest() {
  yield all([
    yield takeEvery(ENCARGOS_CREACION_INICIALIZAR_REQUEST, inicializarCreadorEncargos),
    yield takeEvery(ENCARGOS_CREACION_ESTABLECER_CLIENTE, afterEstablecerCliente),
    yield takeLatest(ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA, buscarYAgregarArticuloPorCodigo),
    yield takeLatest(ENCARGOS_CREACION_ARTICULOS_CREAR_ESTABLECER_A_LINEA, agregarArticuloLinea),
    yield takeLatest([ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA], obtenerFormaMontura),
    yield takeLatest([ENCARGOS_CREACION_APLICAR_DESCUENTO, ENCARGOS_CREACION_BORRAR_DESCUENTO], recalcularPrecioArticulo),
    yield takeLatest(ENCARGOS_CREACION_GUARDAR_REQUEST, guardarEncargos),
    yield takeEvery(ENCARGOS_CREACION_INICIALIZAR_REQUEST, inicializarCreadorEncargos),
    yield takeLatest(ENCARGOS_CREACION_APLICAR_DESCUENTO, recalcularPrecioArticulo),
    yield takeLatest(ENCARGOS_CREACION_SET_GAFA_GRADUADA, setGafaGraduada),
    yield takeLatest(ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA, validarErroresFormulario),
  ]);
}

export default authenticationRequest;
